import React from 'react'
import PropTypes from 'prop-types'
import styles from './RatingDots.module.sass'
import { getRatingColor } from '../../priceRatingColor'

const RatingDots = ({ rating, ...props }) => {
  const renderColor = (rating) => {
    let list = []
    for (let i = 0; i < rating; i++) {
      list.push(
        <span
          className={styles.dot}
          style={{
            backgroundColor: getRatingColor(rating),
          }}
          key={i}
        />
      )
    }
    return list
  }

  const renderGrey = (rating) => {
    let list = []
    for (let i = 0; i < 5 - rating; i++) {
      list.push(<span className={styles.dot} key={i} />)
    }
    return list
  }

  return (
    <div key="ratingDots" className={styles.ratingDots}>
      {renderColor(rating)}
      {renderGrey(rating)}
    </div>
  )
}

RatingDots.propTypes = {
  rating: PropTypes.number,
  size: PropTypes.string,
}

export default RatingDots
